/**
 * Webpack shim for @zoom/download-manager (bundled internally by @zoom/meetingsdk).
 * The UMD build references this package name; CRA needs an explicit resolve target.
 */
class DownloadManagerStub {
  download() {
    throw new Error("@zoom/download-manager shim: download not available in this bundle");
  }
}

module.exports = {
  IDownloadManager: DownloadManagerStub,
  DownloadTask: class DownloadTaskStub {},
};
